import {
    StyledActionsSkeleton,
    StyledImageSkeleton,
    StyledStatsSkeleton,
    StyledStatsWrapperSkeleton,
    StyledTitleSkeleton,
} from "./styled-components";
import { StyledSearchResultsContainer, StyledGridRow } from "../search-results/styled-components";
import { useMediaQuery } from "@kaltura/mediaspace-shared-utils";
import { useTheme } from "@kaltura/mediaspace-shared-styled";

const Card = () => {
    return (
        <div>
            <StyledImageSkeleton variant="rectangular" />
            <StyledTitleSkeleton variant="rectangular" />
            <StyledStatsWrapperSkeleton>
                <StyledStatsSkeleton variant="rectangular" />
                <StyledStatsSkeleton variant="rectangular" />
            </StyledStatsWrapperSkeleton>
            <StyledActionsSkeleton variant="rectangular" />
        </div>
    );
};

/**
 * my media search results skeleton
 */
export function SearchResultsSkeleton() {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down(theme.breakpoints.values.md));

    return (
        <StyledSearchResultsContainer>
            <StyledGridRow>
                {!isSmallScreen && (
                    <>
                        <Card key={"card1"} />
                        <Card key={"card2"} />
                        <Card key={"card3"} />
                    </>
                )}
                {isSmallScreen && (
                    <>
                        <Card key={"sm-card1"} />
                        <Card key={"sm-card2"} />
                    </>
                )}
            </StyledGridRow>
        </StyledSearchResultsContainer>
    );
}
